module.exports = __webpack_public_path__ + "img/shop_flow_bg.a95cec1c.jpg";